import { all, call, put, SagaReturnType, takeLatest } from 'redux-saga/effects';

import * as roomDetailsActions from '@/admin/pages/studyGoRoomDetails/Actions';
import { roomDetailsActionTypes } from '@/admin/pages/studyGoRoomDetails/Constants';
import { processRequest } from '@/services/Api';

import type { GetRoomDetailsRequestAction } from '@/admin/pages/studyGoRoomDetails/Actions';
import type { AdminRoomDetails } from '@/admin/pages/studyGoRoomDetails/types';

interface RoomDetailsApiResponse {
	data: {
		study_go_bridge_room: AdminRoomDetails;
	};
}

export function* handleGetRoomDetailsRequest(action: GetRoomDetailsRequestAction) {
	try {
		const { episodeId, roomId } = action.payload;
		const response: SagaReturnType<typeof processRequest> = yield call(
			processRequest,
			`admin/study_go_bridge/episodes/${episodeId}/rooms/${roomId}`,
			'GET',
		);

		const { study_go_bridge_room } = response.data as RoomDetailsApiResponse['data'];

		yield put(roomDetailsActions.getRoomDetailsSuccess({ room: study_go_bridge_room }));
	} catch (error) {
		const errorMessage = error instanceof Error ? error.message : 'Failed to load room details';
		yield put(roomDetailsActions.getRoomDetailsError(errorMessage));
	}
}

export default function* roomDetailsSagas(): Generator {
	yield all([
		yield takeLatest(
			roomDetailsActionTypes.GET_ROOM_DETAILS_REQUEST,
			handleGetRoomDetailsRequest,
		),
	]);
}
